import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { StyledTableBody } from "./TableBody.styles";
import { TableBodyProps } from "./TableBody.types";

const TableBody: React.FC<TableBodyProps> = ({
	children,
	className,
	...props
}) => {
	const block = new BemIt("TableBody");

	return (
		<StyledTableBody className={addClass(className).after(block)} {...props}>
			{children}
		</StyledTableBody>
	);
};

export default TableBody;
